export enum SectionEnum {
  BANNER = 'banner',
  TESTIMONIAL = 'testimonial',
  PRODUCTS = 'products',
  CATEGORY = 'category',
  TEXT = 'text',
}
